/* BARK · Configurador de Coleira — lógica do modal pop-up */
(function () {
  'use strict';

  var BORDADO = 1000;

  var FONTS = [
    {id:1, name:'DK YELLOW LEMON SUN', css:"'DK Yellow Lemon Sun', 'Fredoka', sans-serif", w:400},
    {id:2, name:'CAPTURE SMALLZ CLEAN', css:"'Capture Smallz Clean', 'Chakra Petch', sans-serif", w:400},
    {id:3, name:'JUDAS CAPS', css:"'JudasCaps Wd', 'JudasCaps', 'Judas Caps', 'Anton', sans-serif", w:400},
    {id:4, name:'AMAZDOOM', css:"'AmazDooM', 'Archivo Black', sans-serif", w:400},
    {id:5, name:'AMAGUSI', css:"'Amagusi', 'Baloo 2', sans-serif", w:400},
    {id:6, name:'ABECEDERI', css:"'Abecederi', 'PT Serif', serif", w:400},
    {id:7, name:'ARCADE CLASSIC', css:"'Arcade Classic', 'Wallpoet', sans-serif", w:400},
    {id:8, name:'ALVIONA', css:"'Alviona', 'Playfair Display', serif", w:400},
    {id:9, name:'COMICABD-REGULAR', css:"'Comicabd-Regular', 'Titan One', sans-serif", w:400},
    {id:10, name:'OLDE ENGLISH', css:"'Olde English', 'UnifrakturMaguntia', serif", w:400}
  ];

  var THREADS = [
    {name:'Branco', hex:'#ffffff', code:'0017'},
    {name:'Preto', hex:'#000000', code:'0020'},
    {name:'Prata', hex:'#adb4b9', code:'0105'},
    {name:'Cinza escuro', hex:'#999999', code:'0108'},
    {name:'Creme', hex:'#f0ddc0', code:'0781'},
    {name:'Dourado', hex:'#e6cc6e', code:'0822'},
    {name:'Mel', hex:'#bc6d0a', code:'0931'},
    {name:'Amarelo', hex:'#ffe600', code:'0311'},
    {name:'Laranja', hex:'#ff9933', code:'1300'},
    {name:'Vermelho', hex:'#e8112d', code:'1704'},
    {name:'Castanho', hex:'#996633', code:'1355'},
    {name:'Rosa', hex:'#ffa0cc', code:'2220'},
    {name:'Rosa-claro', hex:'#ffcccc', code:'2155'},
    {name:'Roxo', hex:'#59118e', code:'2900'},
    {name:'Lilás', hex:'#8a8dc2', code:'3130'},
    {name:'Marinho', hex:'#1e1c77', code:'3333'},
    {name:'Azul', hex:'#00a3d1', code:'4103'},
    {name:'Verde', hex:'#00b760', code:'5613'},
    {name:'Verde-lima', hex:'#d9ff42', code:'5940'},
    {name:'Verde-oliva', hex:'#6e7032', code:'1956'}
  ];
  var LIGHT = ['#ffffff','#f0ddc0','#e6cc6e','#ffe600','#adb4b9','#ffcccc','#d9ff42'];
  var SIZE_LABEL = { 'S':'PEQUENO', 'M':'MÉDIO', 'L':'GRANDE', 'XL':'EXTRA-GRANDE' };
  var COLOR_HEX = {
    'black':'#1c1b16','preto':'#1c1b16','preta':'#1c1b16',
    'green':'#4a5a2f','verde':'#4a5a2f','verde tropa':'#4a5a2f','verde tático':'#4a5a2f','verde tatico':'#4a5a2f',
    'beige':'#c7b393','bege':'#c7b393','pink':'#d28aa3','rosa':'#d28aa3',
    'brown':'#7a5a3a','castanho':'#7a5a3a','red':'#eb0f1d','vermelho':'#eb0f1d','portugal':'#eb0f1d',
    'blue':'#25559c','azul':'#25559c'
  };

  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  function $all(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function money(cents){ return '€' + (cents/100).toFixed(2).replace('.', ','); }
  function fstyle(f){ return 'font-family:'+f.css+';font-weight:'+(f.w||400)+';'+(f.ital?'font-style:italic;':''); }
  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
  function escapeAttr(s){ return escapeHtml(s); }

  function colorHex(name){
    if(!name) return '#777';
    var k = String(name).trim().toLowerCase();
    if (COLOR_HEX[k]) return COLOR_HEX[k];
    return COLOR_HEX[k.split(/[\/\s]/)[0]] || '#777';
  }

  function prettyColor(title){
    var t = String(title||'');
    t = t.replace(/^\s*\d+\s*cm\s+/i, '');
    t = t.replace(/^\s*(coleira|trela|peitoral)\s+/i, '');
    t = t.replace(/^\s*[\d.,]+\s*m\b\s*/i, '');
    t = t.trim() || String(title||'');
    return t.split(/(\s|\/)/).map(function(w){
      if(w==='/' || /^\s+$/.test(w)) return w;
      return w.charAt(0).toUpperCase()+w.slice(1).toLowerCase();
    }).join('');
  }

  function init(root){
    if (root.__bkInit) return;
    root.__bkInit = true;

    var variants = JSON.parse($('[data-bk-variants]', root).textContent || '[]');
    var cfg = JSON.parse($('[data-bk-config]', root).textContent || '{}');
    var family = JSON.parse($('[data-bk-family]', root).textContent || '[]');
    var bordadoVariant = root.getAttribute('data-bordado-variant');
    family.forEach(function(c){ c.name = prettyColor(c.title); });

    var kindCap = cfg.kind || 'coleira';
    kindCap = kindCap.charAt(0).toUpperCase() + kindCap.slice(1);

    var familyMode = family.length > 0;
    var hasColor = familyMode || !!cfg.colorOptionName;
    var hasSize = !!cfg.sizeOptionName;
    var optNames = cfg.optionNames || [];
    var colorIdx = cfg.colorOptionName ? optNames.indexOf(cfg.colorOptionName) : -1;
    var sizeIdx = hasSize ? optNames.indexOf(cfg.sizeOptionName) : -1;
    var sizeCodes = (Array.isArray(cfg.sizeCodes) && cfg.sizeCodes.length) ? cfg.sizeCodes : (cfg.sizeValues || []);
    var sizeNecks = Array.isArray(cfg.sizeNecks) ? cfg.sizeNecks : [];

    var state = { color: hasColor ? null : '__none__', colorEntry: null, size: hasSize ? (sizeCodes[0] || null) : '__none__', name: '', font: FONTS[0], thread: THREADS[0] };

    var n = 0;
    if (hasColor) n++;
    if (hasSize) n++;
    var elN = $('[data-bk-n="name"]', root); if(elN) elN.textContent = n+1;
    elN = $('[data-bk-n="font"]', root); if(elN) elN.textContent = n+2;
    elN = $('[data-bk-n="thread"]', root); if(elN) elN.textContent = n+3;

    var cwrap = $('[data-bk-colors]', root);
    if (familyMode && cwrap) {
      cwrap.innerHTML = family.map(function(c,i){
        return '<button type="button" class="bk-sw" data-i="'+i+'" aria-pressed="false"><span class="bk-dot" style="background:'+c.hex+'"><span class="bk-check">✓</span></span><span class="bk-lbl">'+escapeHtml(c.name)+'</span></button>';
      }).join('');
      cwrap.addEventListener('click', function(e){
        var b = e.target.closest('.bk-sw'); if(!b) return;
        press(cwrap, b); state.colorEntry = family[+b.getAttribute('data-i')]; state.color = state.colorEntry.name; render();
      });
    } else if (hasColor && cwrap) {
      cwrap.innerHTML = (cfg.colorValues||[]).map(function(name){
        return '<button type="button" class="bk-sw" data-val="'+escapeAttr(name)+'" aria-pressed="false"><span class="bk-dot" style="background:'+colorHex(name)+'"><span class="bk-check">✓</span></span><span class="bk-lbl">'+escapeHtml(name)+'</span></button>';
      }).join('');
      cwrap.addEventListener('click', function(e){
        var b = e.target.closest('.bk-sw'); if(!b) return;
        press(cwrap, b); state.color = b.getAttribute('data-val'); render();
      });
    }

    if (hasSize) {
      var swrap = $('[data-bk-sizes]', root);
      swrap.innerHTML = sizeCodes.map(function(code, i){
        var label = SIZE_LABEL[String(code).toUpperCase()] || '';
        var neck = sizeNecks[i] || '';
        var top = label ? (escapeHtml(code) + ' — ' + escapeHtml(label)) : escapeHtml(code);
        return '<button type="button" class="bk-size" data-val="'+escapeAttr(code)+'" aria-pressed="false"><b>'+top+'</b>'+(neck ? '<span>'+escapeHtml(neck)+'</span>' : '')+'</button>';
      }).join('');
      swrap.addEventListener('click', function(e){
        var b = e.target.closest('.bk-size'); if(!b) return;
        press(swrap, b); state.size = b.getAttribute('data-val'); render();
      });
    }

    var fwrap = $('[data-bk-fonts]', root);
    fwrap.innerHTML = FONTS.map(function(f){
      return '<button type="button" class="bk-font" data-id="'+f.id+'" aria-pressed="false" title="'+escapeAttr(f.name)+'" aria-label="'+escapeAttr(f.name)+'"><span class="bk-demo" style="'+fstyle(f)+'">BARK</span></button>';
    }).join('');
    fwrap.addEventListener('click', function(e){
      var b = e.target.closest('.bk-font'); if(!b) return;
      press(fwrap, b);
      var id = +b.getAttribute('data-id');
      state.font = FONTS.find(function(f){ return f.id === id; }) || FONTS[0];
      render();
    });

    var twrap = $('[data-bk-threads]', root);
    twrap.innerHTML = THREADS.map(function(t,i){
      var light = LIGHT.indexOf(t.hex) !== -1;
      return '<button type="button" class="bk-th" data-i="'+i+'" aria-pressed="false" title="'+escapeAttr(t.name)+'" style="background:'+t.hex+';--bk-checkc:'+(light?'#444':'#fff')+'"></button>';
    }).join('');
    twrap.addEventListener('click', function(e){
      var b = e.target.closest('.bk-th'); if(!b) return;
      press(twrap, b); state.thread = THREADS[+b.getAttribute('data-i')]; render();
    });

    var whiteToggle = $('[data-bk-whitetoggle]', root);
    function pickWhite(){ state.thread = THREADS[0]; var first = twrap.querySelector('.bk-th[data-i="0"]'); if(first) press(twrap, first); render(); }
    if (whiteToggle) {
      whiteToggle.addEventListener('click', pickWhite);
      whiteToggle.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pickWhite(); } });
    }

    var nameInput = $('[data-bk-name]', root);
    var countEl = $('[data-bk-count]', root);
    nameInput.addEventListener('input', function(){
      var up = nameInput.value.toUpperCase();
      if (nameInput.value !== up) { var p = nameInput.selectionStart; nameInput.value = up; try{nameInput.setSelectionRange(p,p);}catch(e){} }
      state.name = up.trim();
      countEl.textContent = nameInput.value.length + '/14';
      render();
    });

    function press(group, btn){
      $all('[aria-pressed]', group).forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      btn.setAttribute('aria-pressed','true');
    }

    if (familyMode && cwrap) {
      var curIdx = -1;
      for (var i=0;i<family.length;i++){ if(family[i].current){ curIdx=i; break; } }
      if (curIdx === -1) curIdx = 0;
      state.colorEntry = family[curIdx];
      state.color = state.colorEntry.name;
      var curBtn = cwrap.querySelector('.bk-sw[data-i="'+curIdx+'"]'); if (curBtn) curBtn.setAttribute('aria-pressed','true');
    }
    if (hasSize) { var s0 = $('[data-bk-sizes] .bk-size', root); if (s0) s0.setAttribute('aria-pressed','true'); }
    var f0 = $('[data-bk-fonts] .bk-font', root); if (f0) f0.setAttribute('aria-pressed','true');
    var t0 = $('[data-bk-threads] .bk-th', root); if (t0) t0.setAttribute('aria-pressed','true');

    function findVariant(){
      if (familyMode) {
        var entry = state.colorEntry;
        if (!entry || !entry.variants) return null;
        if (!hasSize) return entry.variants.filter(function(v){ return v.available; })[0] || entry.variants[0] || null;
        return entry.variants.find(function(v){ return v.available && v.size === state.size; }) || entry.variants.find(function(v){ return v.size === state.size; }) || null;
      }
      return variants.filter(function(v){ return v.available; }).find(function(v){
        var okColor = !hasColor || (v.options[colorIdx] === state.color);
        var okSize = !hasSize || (v.options[sizeIdx] === state.size);
        return okColor && okSize;
      });
    }

    var collar = $('[data-bk-collar]', root);
    var pvName = $('[data-bk-pvname]', root);
    var chips = $('[data-bk-chips]', root);
    var threadName = $('[data-bk-threadname]', root);
    var totalEl = $('[data-bk-total]', root);
    var addLabel = $('[data-bk-addlabel]', root);

    function render(){
      if (familyMode && state.colorEntry) collar.style.background = state.colorEntry.hex;
      else if (hasColor && state.color) collar.style.background = colorHex(state.color);

      if (state.name) {
        pvName.textContent = state.name;
        pvName.style.fontFamily = state.font.css;
        pvName.style.fontWeight = state.font.w || 400;
        pvName.style.fontStyle = state.font.ital ? 'italic' : 'normal';
        pvName.style.color = state.thread.hex;
      } else {
        pvName.innerHTML = '<span class="bk-empty">O nome aparece aqui</span>';
      }

      var bits = [];
      if (hasColor && state.color) bits.push(kindCap + ' ' + state.color);
      if (hasSize && state.size) bits.push('Tam. ' + state.size);
      bits.push(state.name ? '"'+state.name+'"' : 'Sem nome');
      if (state.name) { bits.push(state.font.name); bits.push('Linha ' + state.thread.name); }
      chips.innerHTML = bits.map(function(t){ return '<span class="bk-chip">'+escapeHtml(t)+'</span>'; }).join('');

      threadName.textContent = state.thread.name;
      if (whiteToggle) whiteToggle.classList.toggle('off', state.thread.name !== 'Branco');

      var hasName = !!state.name;
      totalEl.textContent = hasName ? money(BORDADO) : '—';
      var v = findVariant();
      addLabel.textContent = v ? ('Adicionar ao carrinho — ' + money(v.price + (hasName ? BORDADO : 0))) : 'Adicionar ao carrinho';
    }

    var formErr = $('[data-bk-formerr]', root);
    var addBtn = $('[data-bk-add]', root);
    addBtn.addEventListener('click', function(){
      formErr.hidden = true;
      var v = findVariant();
      if (!v) { formErr.textContent = 'Esse tamanho está esgotado nesta cor. Tenta outra cor ou tamanho.'; formErr.hidden = false; return; }

      var props = {};
      if (hasColor) props['Cor'] = state.color;
      if (hasSize) props['Tamanho'] = state.size;
      var items = [{ id: v.id, quantity: 1, properties: props }];

      if (state.name) {
        props['Nome bordado'] = state.name;
        props['Tipo de letra'] = state.font.name;
        props['Cor da linha'] = state.thread.name + ' (' + state.thread.code + ')';
        if (bordadoVariant) items.push({ id: parseInt(bordadoVariant,10), quantity: 1 });
      }

      addBtn.disabled = true;
      addLabel.textContent = 'A adicionar…';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          addBtn.disabled = false;
          if (!res.ok) { formErr.textContent = (res.d && res.d.description) || 'Não foi possível adicionar. Tenta de novo.'; formErr.hidden=false; render(); return; }
          closeModal();
          window.location.href = '/cart';
        }).catch(function(){
          addBtn.disabled = false;
          render();
          formErr.textContent = 'Erro de ligação. Tenta de novo.';
          formErr.hidden = false;
        });
    });

    render();
  }

  function openModal(root){
    var ov = $('[data-bk-overlay]', root); if(!ov) return;
    init(root);
    if (root.parentNode !== document.body) document.body.appendChild(root);
    ov.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var first = ov.querySelector('button,input'); if(first) first.focus();
  }

  function closeModal(){
    var ov = document.querySelector('[data-bk-overlay]'); if(!ov) return;
    ov.hidden = true;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function wire(){
    var root = $('[data-bk-cfg]'); if(!root) return;
    document.addEventListener('click', function(e){
      var opener = e.target.closest('[data-bk-open]');
      if (opener) { e.preventDefault(); openModal(root); return; }
      if (e.target.closest('[data-bk-close]')) { closeModal(); return; }
      var ov = document.querySelector('[data-bk-overlay]');
      if (ov && !ov.hidden && e.target === ov) closeModal();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { var ov = document.querySelector('[data-bk-overlay]'); if(ov && !ov.hidden) closeModal(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();
